import {useState} from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material'
import WbButton from '../../../components/common/WbButton'
import WbOutlineButton from '../../../components/common/WbOutlineButton'
import WbAlert from '../../../components/common/WbAlert'
import checkinApi from '../../../services/api/checkin/checkinApi'
import {
  CHECK_IN_ACTION,
  STOP_CONFIRMATION,
  lifecycleActionLabel,
  lifecycleActionsFor,
  lifecycleFailureMessage,
} from '../checkInLifecycle'

const CALL_BY_ACTION = {
  [CHECK_IN_ACTION.pause]: checkinApi.pause,
  [CHECK_IN_ACTION.resume]: checkinApi.resume,
  [CHECK_IN_ACTION.stop]: checkinApi.stop,
}

export default function CheckInLifecycleActions({checkIn, onChanged}) {
  const [running, setRunning] = useState(false)
  const [confirmingStop, setConfirmingStop] = useState(false)

  const actions = lifecycleActionsFor(checkIn?.status)
  if (actions.length === 0) return null

  const run = async action => {
    setRunning(true)
    try {
      await CALL_BY_ACTION[action](checkIn.id)
      onChanged()
    } catch (error) {
      // Without this the button simply looked inert on a rejected transition.
      console.error(`Failed to ${action} check-in`, error)
      WbAlert({type: 'error', message: lifecycleFailureMessage(action)})
    } finally {
      setRunning(false)
    }
  }

  // Stopping is the only one the school cannot undo, so it is the only one that asks.
  const handle = action =>
    action === CHECK_IN_ACTION.stop ? setConfirmingStop(true) : run(action)

  const confirmStop = () => {
    setConfirmingStop(false)
    run(CHECK_IN_ACTION.stop)
  }

  return (
    <>
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        {actions.map(action => (
          <WbButton
            key={action}
            CustomButtonText={lifecycleActionLabel(action)}
            disabled={running}
            onClick={() => handle(action)}
          />
        ))}
      </Stack>

      <Dialog open={confirmingStop} onClose={() => setConfirmingStop(false)}>
        <DialogTitle>Stop check-in</DialogTitle>
        <DialogContent>
          <DialogContentText>{STOP_CONFIRMATION}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <WbOutlineButton
            CustomOutlineButtonText={'Cancel'}
            onClick={() => setConfirmingStop(false)}
          />
          <WbButton CustomButtonText={'Stop Check-In'} onClick={confirmStop} />
        </DialogActions>
      </Dialog>
    </>
  )
}
